import React, {useState} from 'react'
import { Button, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form'
import { InputsFormsReactHook } from '../../components/Forms/InputsFormsReactHook';

const FormularioFormasDePago = ({ labelButton, data, proceso, onClickProcesar }) => {
    if(proceso === 1) {
        data = {}
    }
    const { register, handleSubmit, formState: { errors }, trigger } = useForm({
        defaultValues: {
            CodFormaDePago: data?.codFormaDePago,
            Descripcion: data?.descripcion
        }
    });
    const [isSummit, setIsSummit] = useState(false);

    const onClickAceptar = (event) => {
       onClickProcesar({ ...event });     
    }
    const handleManualValidation = async () => {
        const isValid = await trigger();
        if (!isValid) {
            setIsSummit(true)
        }
    };

    return (
        <>
            <Form  onSubmit={handleSubmit(onClickAceptar)}>
                <Row>
                    <InputsFormsReactHook
                        className="input-form-hook"                        
                        label='Codigo Forma de Pago:'
                        placeholder='Codigo Forma de Pago'
                        mensajeValidacion="El Codigo es requerido"                        
                        errors={errors?.CodFormaDePago?.type}
                        isSummit={isSummit}
                        register={{ ...register('CodFormaDePago', { 
                            required: true,
                            maxLength: 50,
                            minLength: 3
                            }) 
                        }}
                    />
                    <InputsFormsReactHook
                        className="input-form-hook"
                        id='txt-CodFormaDePago'
                        label='Descripción:'
                        placeholder='Descripción Forma de Pago'
                        errors={errors?.Descripcion?.type}                        
                        mensajeValidacion="La descripción es requerida"
                        isSummit={isSummit}
                        register={{ ...register('Descripcion', { 
                            required: true,
                            maxLength: 100
                            })
                        }}
                    />
                </Row>                
                <div className='text-right'>
                    <Button
                        className="mr-1 mb-2 card-button"
                        variant="primary"
                        type="submit"
                        onClick={handleManualValidation}
                        size="sm">
                        <FontAwesomeIcon icon={faFloppyDisk} className="mr-2" />
                        {labelButton}
                    </Button>
                </div>
            </Form>
        </>
    )
}

export default FormularioFormasDePago;
